const CampaignGetter = {
  emailCampaigns: s => s.campaigns.email,
  smsCampaigns: s => s.campaigns.sms,
  pushCampaigns: s => s.campaigns.push,
};

export default CampaignGetter;
